import React from "react";

import styled from "styled-components";
import MQ from "../../styles/mediaQueries";

interface IBoxProps {
  width: number | null;
  padding: number;
}

interface IMinSize {
  minSize: number;
}

export const Overflow = styled.div<IMinSize>`
  margin-bottom: 40px;
  width: 100%;
  min-width: ${p => p.minSize}px;
  @media (min-width: 500px) {
    width: 48%;
  }
` as React.FunctionComponent<IMinSize>;

export const Container = styled.div<IBoxProps>`
  background-color: white;
  width: 100%;
  padding: ${p => p.padding}px;
  border-radius: 10px;
  box-shadow: 0 4px 20px 0 rgba(15, 40, 131, 0.08);
` as React.FunctionComponent<IBoxProps>;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const H2 = styled.h2`
  font-size: 20px;
  font-weight: normal;
  padding: 0;
  margin: 0;
  display: block;
`;
